import type { ReactNode } from 'react';
import { useDismissable } from '@/hooks/useDismissable';

interface Props {
  open: boolean;
  title: string;
  onClose: () => void;
  children: ReactNode;
  footer?: ReactNode;
  /**
   * Дії у ШАПЦI (поруч із заголовком, угорі). Опційно — якщо передано, рендериться
   * праворуч від title. Для форм, де кнопки зручніше тримати вгорі (запит власника).
   */
  headerActions?: ReactNode;
  /**
   * Якщо true, спитати підтвердження перед закриттям (через оверлей або ESC).
   * Кнопки у footer самі вирішують, як обробляти dirty — Drawer не закриває
   * сам при кліку на footer.
   */
  dirty?: boolean;
  /**
   * Ширина drawer. Default — 520px (звичайні форми). 'wide' = 800px
   * (форми з табами + 2-колонковим layout, наприклад OrganizationEditor).
   */
  width?: 'default' | 'wide';
}

export default function Drawer({
  open, title, onClose, children, footer, headerActions, dirty = false, width = 'default',
}: Props) {
  const { tryDismiss } = useDismissable({
    enabled: open,
    dirty,
    onDismiss: onClose,
  });
  if (!open) return null;
  return (
    <>
      <div className="backdrop" onClick={tryDismiss} />
      <aside
        className={`drawer drawer--${width}`}
        role="dialog"
        aria-modal="true"
      >
        {headerActions ? (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                        gap: '1rem', flexWrap: 'wrap', marginBottom: '1.25rem' }}>
            <h2 style={{ margin: 0 }}>{title}</h2>
            <div style={{ display: 'flex', gap: '0.5rem' }}>{headerActions}</div>
          </div>
        ) : (
          <h2>{title}</h2>
        )}
        {children}
        {footer && <div className="drawer__actions">{footer}</div>}
      </aside>
    </>
  );
}
